import { render } from "./OrderArticleDialogComponent.vue?vue&type=template&id=1b8a00e7&ts=true"
import script from "./OrderArticleDialogComponent.vue?vue&type=script&lang=ts"
export * from "./OrderArticleDialogComponent.vue?vue&type=script&lang=ts"

import "./OrderArticleDialogComponent.vue?vue&type=style&index=0&id=1b8a00e7&lang=scss"

import exportComponent from "/codebuild/output/src186264411/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__